export default {
  pt: {
    claimNotice: "Aviso de sinistro",
    contactVelo: "Fale com a Velo",
  },
  en: {
    claimNotice: "Claim notice",
    contactVelo: "Contact Velo",
  },
}; 